import { Box } from '@mui/material';
import { AdviseSupplierInvoice } from '../../../../types/advise';
import { TextSpan } from '../../../Atoms/Text';
import { InvoiceStatusPill } from './InvoiceStatusPill';
import { billingPeriodLabel } from './InvoiceView.calc';

/** The invoice's file name and billing period, with its status. */
export const InvoiceSummary = ({ invoice }: { invoice: AdviseSupplierInvoice }) => (
  <Box className="flex items-center gap-2">
    <TextSpan
      size="sm14"
      color="grey6">
      {[invoice.file_name, billingPeriodLabel(invoice.billing_period)].filter(Boolean).join(' · ')}
    </TextSpan>
    <InvoiceStatusPill invoice={invoice} />
  </Box>
);
